export const $themeColors = {
  'danger': '#3c4b64',
  'primary': '#3c4b64',
  'warning': '#ffc107',
  'light': '#17a2b8'
};
